import { Props, Root, Thumb } from "./Toggle.Parts";
import { CheckmarkIcon } from "./checkmark-icon/CheckmarkIcon";

export const Toggle = ({
  size = "large",
  variant = "normal",
  ref,
  ...rest
}: Props) => {
  return (
    <Root ref={ref} $size={size} $variant={variant} {...rest}>
      <Thumb $size={size}>
        {variant !== "subtle" && <CheckmarkIcon size={size} />}
      </Thumb>
    </Root>
  );
};
